import { AnchorButton, Button } from '@payaca/ambrosia';
import { FC } from 'react';
import { Link } from 'react-router-dom';

type BackToEditingButtonProps = {
  disabled?: boolean;
  /**
   * Route to navigate back to. Renders an anchor so Ctrl/Cmd+click,
   * open-in-new-tab and URL preview work. Provide this or `onClick`.
   */
  to?: string;
  /** In-page state change (not navigation). Renders a button. */
  onClick?: () => void;
  /** Button label. Defaults to "Back to editing". */
  label?: string;
};

const BackToEditingButton: FC<BackToEditingButtonProps> = (props) => {
  const { to, onClick, disabled = false, label = 'Back to editing' } = props;

  if (to !== undefined) {
    return (
      <AnchorButton as={Link} to={to} variant="link" disabled={disabled}>
        {label}
      </AnchorButton>
    );
  }

  return (
    <Button type="button" variant="link" onClick={onClick} disabled={disabled}>
      {label}
    </Button>
  );
};

export default BackToEditingButton;
